<template>
  <vs-popup :title="$t('Preview')" :active.sync="previewModal.show" fullscreen>
      <template v-if="previewModal.link">
        <!--  -->
        <img
          v-if="previewModal.type=='image'"
          width="95%" height="85%"
          class="custom-image-class"
          :src="previewModal.link" />
          <iframe
            v-else
            width="95%" height="85%"
            style="border:none;overflow:hidden;overflow-x:hidden;overflow-y:hidden;position:absolute;"
            class="custom-image-class"
            :src="previewModal.link"
          />
      </template>
      
    </vs-popup>
</template>

<script>
export default {
  props: ['previewModal']
}
</script>

<style>

</style>